import styled from 'styled-components';
import bg from '../../assets/images/login/bg.webp';

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${bg}) no-repeat;
  background-size: 100% 100%;
  position: relative;
  font-family: 'Lato', sans-serif;
  & form {
    width: 30%;
    @media (max-width: 1366px) {
      width: 40%;
    }
  }
  .form-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: white;
    padding: 2rem 2.25rem;
    border-radius: 10px;

    &__title {
      margin-block: 1rem;
      font-size: 1.5rem;
      font-weight: 600;
      color: #120e31;
      text-align: center;
    }

    &__form-control {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;
      margin-top: 20px;
      width: 100%;

      & label {
        margin-left: 7px;
        color: #5a595c;
      }

      & input {
        width: 100%;
        outline: none;
        border-radius: 50px;
        margin-top: 5px;
        padding: 10px 15px;
        border: none;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.38);

        &::placeholder {
          color: #e4e5e5;
        }
      }
    }

    &__btn {
      margin-top: 2rem;
      border: none;
      background: none;
      & img {
        width: 30%;
        @media (max-width: 1366px) {
          width: 40%;
        }
      }
    }
  }
  .form-container__btn {
    background-color: #04a996;
    width: 50%;
    color: #e4e5e5;
    font-size: 1.5rem;
    padding-inline: 20px;
    padding-block: 5px;
    font-weight: bold;
    border-radius: 20px;
  }
  .gsk-logo {
    position: absolute;
    width: 35px;
    bottom: 56px;
    left: 56px;
  }
`;
export const Footer = styled.footer`
  background-color: #04a996;
  height: 20px;
  position: fixed;
  bottom: 0;
  width: 100%;
`;
export const Header = styled.header`
  background: #04a996;
  padding-top: 5px;
  position: relative;
  height: 0.5rem;
  .header-img {
    position: fixed;
    width: 12%;
    top: 0.5rem;
    left: 2rem;
    z-index: 10;
  }
  .logout-img {
    position: fixed;
    top: 1rem;
  }
  & h1 {
    margin-left: 3rem;
    font-size: 1.25rem;
    font-weight: 300;
    color: white;
    font-weight: bold;

    & span {
      position: relative;
      z-index: 1;
      color: #04a996;

      &::before {
        position: absolute;
        content: '';
        width: 127%;
        height: 100%;
        background-color: white;
        margin-left: -3rem;
        z-index: -1;
      }
    }
  }

  & img {
    margin-right: 1.5rem;
    width: 55px;
  }
`;
